import * as devisConf from '@/configuration/devisConf';
import { CATEGORIE_DIVERS } from '@/configuration/produitConf';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';

function generationLigneCommande(produitAssocie, typeRemise,
  tauxTvaDefault) {
  const ligneCommande = genererLigneCommande();
  ligneCommande.typeProduit = produitAssocie.produitEnfant.supportCommercial.categorieVente;
  ligneCommande.produitId = produitAssocie.produitEnfant.id;
  ligneCommande.uniteVente = produitAssocie.uniteVente;
  ligneCommande.etatObtenu = devisConf.AUCUN;
  ligneCommande.dateEtatObtenu = null;
  ligneCommande.selected = false;
  ligneCommande.quantite = produitAssocie.quantite;
  ligneCommande.libelle = produitAssocie.libelle;
  ligneCommande.numerique = produitAssocie.produitEnfant.numerique;
  ligneCommande.produit = {};
  ligneCommande.produit.reference = produitAssocie.produitEnfant.reference;
  ligneCommande.type = devisConf.NORMAL;
  ligneCommande.totalHt = produitAssocie.quantite * produitAssocie.prixUnitaire;
  ligneCommande.referenceEcheancier = null;
  ligneCommande.prixUnitaire = produitAssocie.prixUnitaire;
  ligneCommande.tauxTva = tauxTvaDefault === 0 ? 0
    : tauxTvaDefault || produitAssocie.produitEnfant.tauxTva;
  ligneCommande.remise = produitAssocie.remise ? produitAssocie.remise : 0;
  if (typeRemise === 0) ligneCommande.typeRemise = devisConf.POURCENTAGE;
  else ligneCommande.typeRemise = devisConf.MONTANT;
  if (ligneCommande.typeProduit === CATEGORIE_DIVERS) {
    ligneCommande.produit.produitDivers = produitAssocie.produitEnfant.produitDivers;
  }
  if (produitAssocie.calculAutomatique) {
    ligneCommande.calculAutomatiqueTlpe = true;
  }
  if (produitAssocie.tarifUnitaire) {
    ligneCommande.tarifUnitaire = true;
  }
  return ligneCommande;
}

export default function generationToutesLignesCommandes(produitsAssocies, typeRemise,
  tauxTvaDefault) {
  const lignesCommandes = [];
  if (produitsAssocies) {
    lignesCommandes.push(generationLigneCommande(produitsAssocies, typeRemise, tauxTvaDefault));
    if (produitsAssocies.liaisonsTarif) {
      produitsAssocies.liaisonsTarif.forEach((liaisonTarif => {
        lignesCommandes.push(generationLigneCommande(liaisonTarif, typeRemise, tauxTvaDefault));
      }));
    }
  }
  return lignesCommandes;
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutProduit/genererToutesLignesCommande.js